import { Component } from '../../../libs/gin-tonic/helpers/compiler';

declare let ScrollMagic: any;
declare let TweenMax: any;
declare let Linear: any;

export const ScrollMagicController = new ScrollMagic.Controller();
const ITEM_OFFSET = 30;

@Component({ className: 'js-magic-scroll-stack' })
export class MagicScrollStackComponent {
	private items: NodeListOf<Element> | undefined[] = [];
	private containerHeight = 0;
	private scaler = 0;

	constructor(private element: HTMLElement) {
		if (window.innerWidth > 576) {
			const hook = Number.parseFloat(this.element.getAttribute('data-magic-hook') || '0.5');
			this.items = this.element.querySelectorAll('.js-magic-scroll-stack-item') || [];
			this.containerHeight = this.element.getBoundingClientRect().height;
			this.scaler = 1 / this.items.length;

			this.items.forEach((item, i) => {
				this.setScene(hook, item, i)
			})
		}
	}

	private setScene(hook: number, item: Element, i: number) {
		const offset = this.getOffset(i) + (i * -1 * ITEM_OFFSET);
		const duration = this.containerHeight - offset - this.items[this.items.length - 1].getBoundingClientRect().height;

		// set pin
		new ScrollMagic.Scene({
			triggerElement: this.element,
			triggerHook: hook,
			duration: duration,
			offset: offset,
		})
			.setPin(item, { pushFollowers: this.items.length - 1 == i ? true : false })
			.addTo(ScrollMagicController)
		// .addIndicators({
		// 	name: "stick " + (i + 1),
		// 	colorStart: 'red',
		// 	colorEnd: 'red',
		// 	colorTrigger: 'red',
		// })

		// scale down
		new ScrollMagic.Scene({
			triggerElement: item,
			triggerHook: hook,
			duration: item.getBoundingClientRect().height,
			offset: (i * -1 * ITEM_OFFSET),
		})
			.setTween([
				TweenMax.fromTo(
					item,
					1,
					{
						css: { scaleX: 1, scaleY: 1 }
					},
					{
						css: { scaleX: this.scaler * (i + 1), scaleY: this.scaler * (i + 1) },
						ease: Linear.easeNone,
					}
				),
				TweenMax.fromTo(
					item.querySelectorAll('.js-magic-scroll-stack-slide-target'),
					1,
					{
						css: { opacity: 1 }
					},
					{
						css: { opacity: this.items.length - 1 == i ? 1 : 0 },
						ease: Linear.easeNone
					}
				),
			])
			.addTo(ScrollMagicController)
		// .addIndicators({
		// 	name: "zoom " + (i + 1),
		// 	colorStart: 'green',
		// 	colorEnd: 'green',
		// 	colorTrigger: 'green',
		// })
	}

	private getOffset(i) {
		let offset = 0;
		for (let j = 0; j < i; j++) {
			offset += this.items[j].getBoundingClientRect().height;
		}
		return offset;
	}
}
